const BACKEND_TO_FORM_FIELD = {
  "booker.email": "email",
  "bookerDetails.email": "booker email",
};

export const mapBookingValidationErrors = (fieldErrors = {}) => {
  const mapped = {};

  Object.entries(fieldErrors).forEach(([path, messages]) => {
    const fieldName = BACKEND_TO_FORM_FIELD[path];
    const normalizedMessages = Array.isArray(messages)
      ? messages.filter(Boolean)
      : messages
        ? [String(messages)]
        : [];

    if (fieldName && normalizedMessages.length) {
      mapped[fieldName] = normalizedMessages;
    }
  });

  return mapped;
};

export const applyBookingFormValidationErrors = (formComponent, fieldErrors) => {
  const observer = formComponent?.$refs?.observer;
  if (!observer || !fieldErrors) {
    return false;
  }

  const mappedErrors = mapBookingValidationErrors(fieldErrors);
  if (!Object.keys(mappedErrors).length) {
    return false;
  }

  observer.setErrors(mappedErrors);

  const firstErrorField = Object.values(observer.refs || {}).find(
    (field) => field?.errors?.length
  );

  if (firstErrorField?.$el) {
    firstErrorField.$el.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  return true;
};

export const stashBookingValidationErrors = (propertyId, fieldErrors) => {
  if (!propertyId || !fieldErrors || !Object.keys(fieldErrors).length) {
    return;
  }

  sessionStorage.setItem(
    `bookingValidationErrors-${propertyId}`,
    JSON.stringify(fieldErrors)
  );
};

export const consumeBookingValidationErrors = (propertyId) => {
  if (!propertyId) {
    return null;
  }

  const storageKey = `bookingValidationErrors-${propertyId}`;
  const raw = sessionStorage.getItem(storageKey);
  if (!raw) {
    return null;
  }

  sessionStorage.removeItem(storageKey);

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
